import { theme } from 'antd';
import {
  AlertOutlined,
  MessageOutlined,
  TeamOutlined,
  WarningOutlined
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { StatCard } from '@/components/ui/StatCard';
import { StatCardGrid } from '@/components/ui/StatCardGrid';

export type ConversationOverviewAggregateStats = {
  totalConversations: number;
  technicalIssueCount: number;
  technicalIssuePercent: number;
  humanHandoffCount: number;
  humanHandoffPercent: number;
  redFlagCount: number;
  redFlagPercent: number;
};

type ConversationOverviewStatsProps = {
  stats: ConversationOverviewAggregateStats;
  loading?: boolean;
};

/**
 * KPI row of the conversation overview: total conversations plus technical issues,
 * human handoffs and red flags with their share of the total.
 */
export function ConversationOverviewStats({ stats, loading }: ConversationOverviewStatsProps) {
  const { t } = useTranslation('admin');
  const { token } = theme.useToken();

  return (
    <StatCardGrid>
      <StatCard
        label={t('conversationOverview.columns.total')}
        value={stats.totalConversations}
        icon={<MessageOutlined />}
        loading={loading}
      />
      <StatCard
        label={t('conversationOverview.columns.technicalIssue')}
        value={stats.technicalIssueCount}
        suffix={`(${stats.technicalIssuePercent}%)`}
        icon={<WarningOutlined />}
        color={token.colorWarning}
        loading={loading}
      />
      <StatCard
        label={t('conversationOverview.columns.humanHandoff')}
        value={stats.humanHandoffCount}
        suffix={`(${stats.humanHandoffPercent}%)`}
        icon={<TeamOutlined />}
        color={token.colorInfo}
        loading={loading}
      />
      <StatCard
        label={t('conversationOverview.columns.flaggedRed')}
        value={stats.redFlagCount}
        suffix={`(${stats.redFlagPercent}%)`}
        icon={<AlertOutlined />}
        color={token.colorError}
        loading={loading}
      />
    </StatCardGrid>
  );
}
